import React from 'react';

import DashboardWidgetWrapper from '../DashboardWidgetWrapper';

const LinksMetricsWidget = () => {
	return (
		<DashboardWidgetWrapper label={'Links Metrics'}>
			<p>Hello</p>
		</DashboardWidgetWrapper>
	);
};

LinksMetricsWidget.propTypes = {};

export default LinksMetricsWidget;
